module.exports = __webpack_public_path__ + "static/media/brandTruffle.b62b0aa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brandTruffle.png
// module id = 750
// module chunks = 1 3